import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import classNames from 'classnames'

import './styles.css'

const ThreeImages = ({ left, center, right, notCentered }) => (
  <div
    className={classNames({
      'w-100 mw560': true,
      center: !notCentered
    })}
  >
    <div className="flex items-center mh--2">
      <div className="w-32 ph2">
        <Img sizes={left} alt="" />
      </div>
      <div className="w-36 ph2">
        <Img sizes={center} alt="" />
      </div>
      <div className="w-32 ph2">
        <Img sizes={right} alt="" />
      </div>
    </div>
  </div>
)

ThreeImages.propTypes = {
  left: PropTypes.object,
  center: PropTypes.object,
  right: PropTypes.object
}

export default ThreeImages



// WEBPACK FOOTER //
// ./src/components/three-images/three-images.js